/* eslint camelcase: 0 */
import { CredentialResponse } from '@react-oauth/google';
import { notification } from 'antd';
import { renderUrl } from '../../lib';
import routes from '../../pages/routes';

const handleGoogleSuccess = (
    googleUserResponse: CredentialResponse,
    redirectFn: (redir: string) => void,
    queryParams?: Record<string, string>
): void => {
    if ('credential' in googleUserResponse) {
        const { credential } = googleUserResponse;
        redirectFn(
            renderUrl(routes.googleAuth.path, undefined, {
                ...queryParams,
                credential,
            })
        );
    } else
        notification.error({
            message: 'Você está offline. Tente novamente mais tarde.',
        });
};

const handleGoogleFailure = (): void =>
    notification.error({
        key: 'googleAuthFailure',
        message:
            'Não foi possível autenticar sua requisição. ' +
            'Tente novamente mais tarde.',
    });

export { handleGoogleFailure, handleGoogleSuccess };
